import React from "react";
import TextInput from "../../Components/Inputs/TextInput";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import {useSelector} from "react-redux";
import DateInput from "../../Components/Inputs/DateInput";
import TreePicker from "../../Components/Inputs/TreePicker";


const yesNoOptions = [
  {id: 0, name: 'No'},
  {id: 1, name: 'Yes'},
];

const publishOptions = [
  {'id': 1, 'name': 'Published'},
  {'id': 0, 'name': 'Unpublished'}
];

export default function ({register, errors, control, data, watch}) {
  const user = useSelector(state => state.user);
  const isAdmin = user?.roles?.includes('Super Admin');

  console.log('ProductFilters data', data);

  return (
    <>
      <ReactSelectInput
        label='Bundle'
        name='bundle'
        control={control}
        errorMessage={errors?.bundle}
        options={yesNoOptions}
        inputClassName='col-xxl-3 col-lg-6 mb-5'
      />

      <ReactSelectInput
        label='Sale'
        name='sale'
        control={control}
        errorMessage={errors?.sale}
        options={yesNoOptions}
        inputClassName='col-xxl-3 col-lg-6 mb-5'
      />

      <TextInput
        label='Min price'
        name='min_price'
        register={register}
        errorMessage={errors?.min_price}
        parentClasses='col-xxl-3 col-lg-6'
      />

      <TextInput
        label='Max price'
        name='max_price'
        register={register}
        errorMessage={errors?.max_price}
        parentClasses='col-xxl-3 col-lg-6'
      />

      {isAdmin && (
        <ReactSelectInput
          label='Seller'
          name='shop_id'
          control={control}
          errorMessage={errors?.shop_id}
          options={data?.shops}
          inputClassName='col-xxl-3 col-lg-6 mb-5'
        />
      )}

      {isAdmin && (
        <ReactSelectInput
          label='Brands'
          name='brand_id'
          control={control}
          errorMessage={errors?.brand_id}
          options={data?.brands}
          inputClassName='col-xxl-3 col-lg-6 mb-5'
        />
      )}

      <ReactSelectInput
        label='Publish Status'
        name='published'
        control={control}
        errorMessage={errors?.published}
        options={publishOptions}
        inputClassName='col-xxl-3 col-lg-6 mb-5'
      />

      <DateInput
        label='Start date'
        name='start_date'
        register={register}
        errorMessage={errors?.start_date}
        parentClasses='col-xxl-3 col-lg-6'
      />

      <DateInput
        label='End date'
        name='end_date'
        register={register}
        errorMessage={errors?.end_date}
        parentClasses='col-xxl-3 col-lg-6'
      />
     
      <TextInput
        label='Min quantity'
        name='min_quantity'
        register={register}
        errorMessage={errors?.min_quantity}
        parentClasses='col-xxl-3 col-lg-6'
      />

      <TextInput
        label='Max quantity'
        name='max_quantity'
        register={register}
        errorMessage={errors?.max_quantity}
        parentClasses='col-xxl-3 col-lg-6'
      />

      <TreePicker
        label='Category'
        name='category_id'
        control={control}
        errorMessage={errors?.category_id}
        options={data?.categoriesTree}
        inputClassName='col-xxl-3 col-lg-6'
        watch={watch}
        optionLabel="label"
        optionValue="value"
      />
    </>
  );
}
